import { Card } from 'antd';
import { FC, ReactNode } from 'react';

interface ProfileRowInfoProps {
  label: string;
  value: string | ReactNode;
}

const ProfileRowInfo: FC<ProfileRowInfoProps> = ({ label, value }) => {
  return (
    <>
      <div style={{ width: '100%', display: 'flex', flexDirection: 'row' }}>
        <Card
          style={{ width: '20%', height: 50, background: 'var(--neutral-3)', display: 'flex', alignItems: 'center' }}
        >
          {label}
        </Card>
        <Card style={{ width: '80%', height: 50, background: 'white', display: 'flex', alignItems: 'center' }}>
          {value}
        </Card>
      </div>
    </>
  );
};

export default ProfileRowInfo;
